module.exports = __webpack_public_path__ + "img/TU.eedeef81.svg";